import React from 'react';
import PropTypes from 'prop-types';
import { Button, Spinner } from 'react-bootstrap';

const ReportActionButtons = React.forwardRef(
  (
    {
      showFloatingQuickSave,
      saving,
      submitting,
      isComplete,
      onSaveDraft,
      onSubmit,
      committeeName,
    },
    ref,
  ) => (
    <>
      <div ref={ref} className="d-flex gap-2 justify-content-end mt-4 mb-3">
        <Button
          variant="outline-primary"
          onClick={onSaveDraft}
          disabled={saving || submitting}
          className="standard-width-button px-4 py-2"
          style={{ fontSize: '1rem' }}
        >
          {saving ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Saving...
            </>
          ) : (
            <>Save Draft</>
          )}
        </Button>
        <Button
          variant="success"
          onClick={onSubmit}
          disabled={saving || submitting || !isComplete}
          className="standard-width-button px-4 py-2"
          title={
            !isComplete
              ? 'All fields must be completed before submitting'
              : 'Submit report to Council'
          }
          style={{ fontSize: '1rem' }}
        >
          {submitting ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Submitting...
            </>
          ) : (
            <>Submit</>
          )}
        </Button>
      </div>

      {showFloatingQuickSave && (
        <div className="floating-save">
          {committeeName && (
            <div className="text-muted floating-save__label mb-1">
              {committeeName}
            </div>
          )}
          <Button
            variant="outline-primary"
            onClick={onSaveDraft}
            disabled={saving || submitting}
            className="shadow-lg floating-save__btn px-3 py-2"
            title="Save Draft"
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" className="me-1" />
                Saving
              </>
            ) : (
              <>
                <i className="fas fa-save" />
                <span className="floating-save__text">&nbsp;Save Draft</span>
              </>
            )}
          </Button>
        </div>
      )}
    </>
  ),
);

ReportActionButtons.displayName = 'ReportActionButtons';

ReportActionButtons.propTypes = {
  showFloatingQuickSave: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  isComplete: PropTypes.bool.isRequired,
  onSaveDraft: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  committeeName: PropTypes.string,
};

ReportActionButtons.defaultProps = {
  committeeName: null,
};

export default ReportActionButtons;
